import type { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "../Icon";
import type { IconType } from "../Icon";

export const ListItemIconTile = ({
  icon,
  size = 1.3,
  ...divProps
}: {
  icon: IconType;
  size?: number;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      {...divProps}
      className={twMerge(
        "m-0 flex shrink-0 items-center justify-center rounded-lg bg-zinc-100 p-2 leading-none text-zinc-800",
        divProps.className,
      )}
    >
      <Icon icon={icon} size={size} />
    </div>
  );
};
